import React from 'react'
import { AiOutlineClose } from 'react-icons/ai'
import { HiMenuAlt4 } from 'react-icons/hi'

const NavItem = ({ title, className }) => {
  return <li className={`mx-4 cursor-pointer ${className}`}>{title}</li>
}

const Navbar = () => {
  const [toggleNav, setToggleNav] = React.useState(false)

  return (
    <nav className='w-full flex md:justify-center justify-between items-center p-4'>
      <div className='md:flex-[0.5] flex-initial justify-center items-center'>
        <img
          src='images/logo.png'
          alt='Krypt'
          className='w-32 cursor-pointer'
        />
      </div>
      <ul className='text-white md:flex hidden list-none flex-row justify-between items-center flex-initial'>
        {['Market', 'Exchange', 'Tutorials', 'Wallet'].map((title, index) => (
          <NavItem key={index} title={title} />
        ))}
        <li className='bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#2546bd] duration-300'>
          Login
        </li>
      </ul>
      <div className='flex relative md:hidden'>
        <div
          className='text-white cursor-pointer'
          onClick={() => setToggleNav(!toggleNav)}
        >
          {toggleNav ? (
            <AiOutlineClose fontSize={28} />
          ) : (
            <HiMenuAlt4 fontSize={28} />
          )}
        </div>
        {toggleNav && (
          <ul className='z-10 fixed -top-0 -right-2 p-3 w-[70vw] h-screen shadow-2xl md:hidden list-none flex flex-col justify-start items-end rounded-md blue-glassmorphism text-white animate-slide-in'>
            <li
              className='text-xl w-full my-2 aimate-slide-in'
              onClick={() => setToggleNav(false)}
            >
              <AiOutlineClose fontSize={28} />
            </li>
            {['Market', 'Exchange', 'Tutorials', 'Wallet'].map(
              (title, index) => (
                <NavItem key={index} title={title} className='my-2 text-lg' />
              )
            )}
          </ul>
        )}
      </div>
    </nav>
  )
}

export default Navbar
